import type { Cell, Direction } from './types';

export const directionVectors: Readonly<Record<Direction, Cell>> = {
  up: { x: 0, y: -1 },
  right: { x: 1, y: 0 },
  down: { x: 0, y: 1 },
  left: { x: -1, y: 0 },
};

export function cellKey(cell: Cell): string {
  return `${cell.x}:${cell.y}`;
}

export function directionBetween(from: Cell, to: Cell): Direction {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  if (dx === 0 && dy < 0) return 'up';
  if (dx > 0 && dy === 0) return 'right';
  if (dx === 0 && dy > 0) return 'down';
  if (dx < 0 && dy === 0) return 'left';
  throw new Error(`Cells ${cellKey(from)} and ${cellKey(to)} do not define a direction.`);
}

export function distanceAhead(
  origin: Cell,
  candidate: Cell,
  direction: Direction,
): number | null {
  switch (direction) {
    case 'up':
      return candidate.x === origin.x && candidate.y < origin.y
        ? origin.y - candidate.y
        : null;
    case 'right':
      return candidate.y === origin.y && candidate.x > origin.x
        ? candidate.x - origin.x
        : null;
    case 'down':
      return candidate.x === origin.x && candidate.y > origin.y
        ? candidate.y - origin.y
        : null;
    case 'left':
      return candidate.y === origin.y && candidate.x < origin.x
        ? origin.x - candidate.x
        : null;
  }
}

export function isAhead(origin: Cell, candidate: Cell, direction: Direction): boolean {
  return distanceAhead(origin, candidate, direction) !== null;
}

export function isTurn(first: Cell, middle: Cell, last: Cell): boolean {
  return middle.x - first.x !== last.x - middle.x
    || middle.y - first.y !== last.y - middle.y;
}
